import { format } from "date-fns";

import { convertTimeToDate } from "../utils/convertTimeToDate";

export const formatTime = (time: string) => {
  const formattedTime = convertTimeToDate(time);
  const timeFormat = formattedTime.getMinutes() !== 0 ? "h.mm aaa" : "h aaa";

  return format(formattedTime, timeFormat);
};
